import { IconHome, IconMoreStroked } from '@douyinfe/semi-icons'
import { Button, Card, Typography } from '@douyinfe/semi-ui'
import { useNavigate } from 'react-router-dom'

export function NotFoundPage() {
  const navigate = useNavigate()
  return (
    <div
      style={{
        minHeight: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Card
        style={{ textAlign: 'center', padding: 64, borderRadius: 16 }}
        shadows="always"
      >
        <div
          style={{
            width: 80,
            height: 80,
            borderRadius: 24,
            backgroundColor: 'var(--semi-color-primary-light-default)',
            color: 'var(--semi-color-primary)',
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: 40,
            marginBottom: 24,
          }}
        >
          <IconMoreStroked />
        </div>
        <Typography.Title heading={1} style={{ marginBottom: 8 }}>
          404
        </Typography.Title>
        <Typography.Title heading={4} style={{ marginBottom: 16 }}>
          页面不存在
        </Typography.Title>
        <Typography.Paragraph type="tertiary" style={{ marginBottom: 24 }}>
          您访问的页面可能已被移除或地址有误
        </Typography.Paragraph>
        <Button
          type="primary"
          icon={<IconHome />}
          onClick={() => navigate('/')}
        >
          返回首页
        </Button>
      </Card>
    </div>
  )
}
